import {useMutation, useQueryClient} from '@tanstack/react-query'

import {postImage} from './api'
import {imageKeys} from './keys'
import type {ImageRequest} from './types'

export const useUploadImage = () => {
  const queryClient = useQueryClient()

  return useMutation<string, unknown, ImageRequest>({
    mutationFn: postImage,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({queryKey: imageKeys.get(variables.type, variables.id)})
    },
  })
}
